import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/gossipData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open
          ? "bg-paper-50/95 backdrop-blur border-b border-ink-800/10"
          : "bg-paper-50/70"
      }`}
    >
      <nav className="mx-auto flex h-16 items-center justify-between px-4 md:px-6 max-w-[1360px]">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-3 whitespace-nowrap"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-sign-500 text-paper-50">
            <i className="ri-focus-3-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-wide text-ink-900">
              真瓜研究所
            </span>
            <span className="mt-1 text-[11px] tracking-[0.2em] text-ink-500">
              CHIGUA·LAB
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => {
                e.preventDefault();
                go(l.id);
              }}
              className="whitespace-nowrap text-sm font-medium text-ink-600 transition-colors hover:text-sign-600"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <button
            type="button"
            onClick={() => document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" })}
            className="whitespace-nowrap rounded-md bg-sign-500 px-4 py-2 text-sm font-semibold text-paper-50 transition-colors hover:bg-sign-600"
          >
            订阅早报
          </button>
        </div>

        <button
          type="button"
          aria-label="展开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md border border-ink-800/15 text-ink-700 md:hidden"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-ink-800/10 bg-paper-50 px-4 pb-5 pt-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  go(l.id);
                }}
                className="rounded-md px-3 py-3 text-sm font-medium text-ink-700 transition-colors hover:bg-sign-100 hover:text-sign-700"
              >
                {l.label}
              </a>
            ))}
            <button
              type="button"
              onClick={() => {
                setOpen(false);
                document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-2 whitespace-nowrap rounded-md bg-sign-500 px-4 py-3 text-sm font-semibold text-paper-50"
            >
              订阅早报
            </button>
          </div>
        </div>
      )}
    </header>
  );
}